import * as React from 'react';
import clsx from 'clsx';
import { StatusIcon } from '../../../components/Private';
import Svg from '../../../components/Svg';
var svgStyles = {
  "root": "SVG-root_1gLEH",
  "fill-green": "SVG-fill-green_3XEHx",
  "fill-blue": "SVG-fill-blue_3XxuW",
  "fill-grey-lighter": "SVG-fill-grey-lighter_ZsArp",
  "fill-grey-light": "SVG-fill-grey-light_2xlhv",
  "fill-grey": "SVG-fill-grey_BVkZ6",
  "fill-grey-dark": "SVG-fill-grey-dark_BCV7H",
  "fill-grey-darker": "SVG-fill-grey-darker_24g8W",
  "fill-anthracite": "SVG-fill-anthracite_7Va6z",
  "fill-yellow": "SVG-fill-yellow_1DmnQ",
  "fill-yellow-dark": "SVG-fill-yellow-dark_oJJ2l",
  "fill-yellow-darker": "SVG-fill-yellow-darker_3Tu8T",
  "fill-red": "SVG-fill-red_1zjVE",
  "fill-unknown": "SVG-fill-unknown_cu2te SVG-fill-grey-dark_BCV7H",
  "fill-info": "SVG-fill-info_dJHzJ",
  "fill-success": "SVG-fill-success_2sUEP",
  "fill-warning": "SVG-fill-warning_3l7NA",
  "fill-danger": "SVG-fill-danger_3h58E",
  "fill-progress": "SVG-fill-progress_1wmR1 SVG-fill-info_dJHzJ",
  "fill-white": "SVG-fill-white_1ifIm",
  "fill-brand": "SVG-fill-brand_i34iV",
  "fill-neutral-weak": "SVG-fill-neutral-weak_RUQEU",
  "fill-neutral-plain": "SVG-fill-neutral-plain_3jzV-",
  "fill-neutral-strong": "SVG-fill-neutral-strong_2iDzN",
  "fill-disabled": "SVG-fill-disabled_2Wv9a",
  "fill-informative": "SVG-fill-informative_2TJ7Q",
  "fill-positive": "SVG-fill-positive_A2UHl",
  "fill-notice": "SVG-fill-notice_99WSg",
  "fill-negative": "SVG-fill-negative_2JTXR"
};
import { CellContext } from '../context';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "ListCell-root_1HxzV",
  "grouped": "ListCell-grouped_1YKqx",
  "primary": "ListCell-primary_1AlGh",
  "secondary": "ListCell-secondary_Gp2Ih Widget-hoverChild_1azKL",
  "with-icon": "ListCell-with-icon_2Enbd",
  "icon": "ListCell-icon_VwfQD",
  "statusIcon": "ListCell-statusIcon_3Hcxs",
  "icon-prefix": "ListCell-icon-prefix_17Fv5",
  "icon-suffix": "ListCell-icon-suffix_3fQvp"
};
function ListCell({
  type = 'primary',
  icon,
  statusIcon,
  iconProps,
  children,
  className,
  grouped,
  classes,
  ...extraProps
}) {
  const context = React.useContext(CellContext);
  const classOf = key => classes?.[key] ?? '';
  const isGrouped = typeof grouped === 'boolean' ? grouped : context.grouped;
  const hasIcon = icon && Svg.has(icon.name);
  const hasStatusIcon = typeof statusIcon?.position === 'string' && typeof statusIcon?.theme === 'string';
  const renderIcon = () => {
    if (!icon || !hasIcon) return null;
    return /*#__PURE__*/_jsx(Svg, {
      name: icon.name,
      className: clsx(styles.icon, {
        [styles['icon-prefix']]: icon.position === 'prefix',
        [styles['icon-suffix']]: icon.position === 'suffix',
        [svgStyles[`fill-${icon.fill}`]]: icon.fill
      }, classOf('icon')),
      ...iconProps
    });
  };
  const renderStatusIcon = () => {
    if (!statusIcon || !hasStatusIcon) return null;
    return /*#__PURE__*/_jsx(StatusIcon, {
      intent: statusIcon.theme,
      className: clsx(styles.statusIcon, {
        [styles['icon-prefix']]: statusIcon.position === 'prefix',
        [styles['icon-suffix']]: statusIcon.position === 'suffix'
      }, classOf('icon'))
    });
  };
  const rootClasses = clsx(styles.root, {
    [styles.primary]: type === 'primary',
    [styles.secondary]: type === 'secondary',
    [styles.grouped]: isGrouped,
    [styles['with-icon']]: hasIcon || hasStatusIcon
  }, classOf('root'), className);
  return /*#__PURE__*/_jsxs("span", {
    className: rootClasses,
    ...extraProps,
    children: [hasIcon && renderIcon(), hasStatusIcon && renderStatusIcon(), children]
  });
}
export default ListCell;